<template>
	<div :class="[error ? 'error' : '']">
		<slot name="label">
			<label
				v-if="label"
				:for="name"
				:class="[labelClass]"
				class="block font-medium text-gray-700"
			>
				{{ label }}
			</label>
		</slot>

		<div class="relative">
			<div
				v-if="hasLeadingIcon"
				class="absolute inset-y-0 left-0 flex items-center pl-3"
				@click="$emit('clickLeadingIcon')"
			>
				<slot name="leadingIcon" />
			</div>

			<input
				:id="id"
				ref="input"
				:name="name"
				:placeholder="placeholder"
				class="ring-none block appearance-none rounded border border-gray-200 px-3 pb-2 pt-2 shadow-none outline-none ring-transparent focus:border-blue-400/60 focus:shadow-md focus:shadow-blue-400/20 focus:outline-none"
				:class="[
					inputClass,
					inputWidth,
					hasLeadingIcon ? inputLeadingIconPaddingLeft : '',
					hasTrailingIcon ? inputTrailingIconPaddingRight : '',
				]"
				:value="modelValue"
				@input="$emit('update:modelValue', $event.target.value)"
			/>

			<div
				v-if="hasTrailingIcon"
				class="absolute inset-y-0 right-0 flex items-center pr-3"
				@click="$emit('clickTrailingIcon')"
			>
				<slot name="trailingIcon" />
			</div>
		</div>

		<div v-if="error && showError" class="mt-1.5 flex items-center">
			<div class="mr-1 h-4 w-1 rounded bg-red-400"></div>
			<div class="text-sm leading-none text-red-400 opacity-70">
				{{ error }}
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
	modelValue: String,
	id: {
		type: String,
		default: null,
		required: false,
	},
	name: {
		type: String,
		required: true,
	},
	label: {
		type: String,
		default: null,
		required: false,
	},
	placeholder: {
		type: String,
		required: false,
	},
	labelClass: {
		type: String,
		required: false,
	},
	inputClass: {
		type: String,
		required: false,
	},
	inputLeadingIconPaddingLeft: {
		type: String,
		default: 'pl-10',
		required: false,
	},
	inputTrailingIconPaddingRight: {
		type: String,
		default: 'pr-10',
		required: false,
	},
	inputWidth: {
		type: String,
		default: 'w-full',
		required: false,
	},
	error: {
		type: [String, Boolean],
		default: false,
		required: false,
	},
	showError: {
		type: Boolean,
		default: true,
		required: false,
	},
	backgroundColor: {
		type: String,
		default: 'bg-white',
		required: false,
	},
	hasLeadingIcon: {
		type: Boolean,
		default: false,
		required: false,
	},
	hasTrailingIcon: {
		type: Boolean,
		default: false,
		required: false,
	},
})

const emits = defineEmits([
	'update:modelValue',
	'clickLeadingIcon',
	'clickTrailingIcon',
])

const input = ref(null)

defineExpose({ input })
</script>
